import React, {useContext, useEffect, useState} from 'react';
import ProductPrice, {priceFormat} from "../Product/ProductPrice";
import './CartOverview.scss';
import AppContext from "../../store";
import {TYPE_FULL_WIDTH} from "../Buttons/ButtonShop";
import ButtonShopRedirect from "../Buttons/ButtonShopRedirect";
import {TEXT_FIND_IN_SHOP, TEXT_GOMLVL_SHORT} from "../../contants/common";
// import useScreenOrientationExtended from "../../hooks/useScreenOrientationExtended";
// import useDeviceSizeDetect from "../../hooks/useDeviceSizeDetect";

export default function CartOverview() {
	const {
		activeBundleId,
		selectedOptions,
		getBundleById,
		getTotalPrice,
		toggleConfiguratorPortal,
	} = useContext(AppContext);
	const [title, setTitle] = useState('');
	const [price, setPrice] = useState('');
	// const {isLandscape} = useScreenOrientationExtended();
	// const detectMobile = useDeviceSizeDetect();

	/*@TODO IPhone issue | Always returns false on IPhone*/
	// const isProductPriceAppear = useMemo(() => {
	// 	return detectMobile.isMobile() && isLandscape
	// }, [detectMobile, isLandscape]);

	useEffect(() => {
		const bundle = getBundleById(activeBundleId);
		if(bundle) {
			setTitle(bundle.title);
		}
	}, [activeBundleId]);

	useEffect(() => {
		const price = getTotalPrice();
		if(price) {
			setPrice(price);
		}
	}, [selectedOptions]);

	return (
		<div className='cart-overview-container'>
			{/*<div className="cart-overview-column">*/}
				<div className="cart-overview-title">{TEXT_GOMLVL_SHORT} <span className="bold">{title}</span></div>
				<div className="cart-overview-info">
					<div className="cart-overview-price visible-device-small">
						ab&nbsp;<ProductPrice {...priceFormat(price)}/>
					</div>
					<span
						onClick={() => toggleConfiguratorPortal(true)}
						data-text-mobile={'zur Übersicht'}
						data-text-desktop={'Übersicht anzeigen'}
						className="cart-overview-readMore"></span>
				</div>
			{/*</div>*/}
			<div style={{width: "100%"}} className="cart-overview-column">
				<ButtonShopRedirect
					size={TYPE_FULL_WIDTH}
					text={TEXT_FIND_IN_SHOP}
				/>
			</div>
		</div>
	)
}
